import { render, staticRenderFns } from "./AnnualPlayerRanking2025.vue?vue&type=template&id=a5b34544&scoped=true"
import script from "./AnnualPlayerRanking2025.vue?vue&type=script&lang=js"
export * from "./AnnualPlayerRanking2025.vue?vue&type=script&lang=js"
import style0 from "./AnnualPlayerRanking2025.vue?vue&type=style&index=0&id=a5b34544&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5b34544",
  null
  
)

export default component.exports